export const EquipInsuranceTypes = {
  extend: 'extensionPolicy',
  accident: 'accidentPolicy'
}

export const EquipInsuranceTypeNames = {
  extensionPolicy: '家充卫士-延长质保',
  accidentPolicy: '家充卫士-意外保障'
}

export const EquipInsuranceTitles = {
  extensionPolicy: { effect: '有效期', buyTime: '购买时间', buyer: '购买人', action: '延长质保' },
  accidentPolicy: { effect: '有效期', buyTime: '投保时间', buyer: '投保人', action: '立即续费' }
}

export const EquipInsuranceTypeShortNames = {
  extensionPolicy: '服务',
  accidentPolicy: '保障'
}

export const EquipInsuranceSpuIds = {
  dev: {
    extensionPolicy: '1562256570036375554',
    accidentPolicy: '1559828762433794050',
    combinePolicy: '1562387529138548737'
  },
  test: {
    extensionPolicy: '1562256570036375554',
    accidentPolicy: '1559828762433794050',
    combinePolicy: '1562387529138548737'
  },
  pre: {
    extensionPolicy: '1566683673749139458',
    accidentPolicy: '1566683920734924802',
    combinePolicy: '1566683471432691713'
  },
  production: {
    extensionPolicy: '1570353557412089858',
    accidentPolicy: '1570353515424841729',
    combinePolicy: '1570354038022537218'
  }
}

export type SimpleFn = () => void

export const OAuthTypes = {
  // 新保
  NEW_INSURANCE: 1,
  // 续保
  RENEW_INSURANCE: 2,
  // 发起报案前的授权
  REPORT_CASE_HOME: 3,
  // 进入线上报案时的授权
  REPORT_CASE_ONLINE: 4,
  // 保司案件回传查看案件时的授权
  REPORT_CASE_COMPANY: 7,
  // 新保预约投保
  NEW_INSURANCE_RESERVE: 8
}

export const OAuthVersions = {
  [OAuthTypes.NEW_INSURANCE]: 5,
  [OAuthTypes.RENEW_INSURANCE]: 5,
  [OAuthTypes.REPORT_CASE_HOME]: 4,
  [OAuthTypes.REPORT_CASE_ONLINE]: 2,
  [OAuthTypes.REPORT_CASE_COMPANY]: 1,
  [OAuthTypes.NEW_INSURANCE_RESERVE]: 1
}

export const QuestionTypeNames = {
  0: '单选',
  1: '多选'
}

export const InsPolicyStateCodes = {
  // 已生效
  EFFECT: '2',
  // 待生效
  PEDNING_EFFECT: '3'
}

export const ErrCodes = {
  SUCCESS: 0,
  NOT_XP_APP: 1,
  JS_ERROR: 2
}

export const CaseStateCodes = {
  INS_ACCEPTED: '0',
  SURVEYED: '1',
  EVALUATED: '3',
  APPROVED: '4',
  PAID: '5',
  // 终态
  CLOSED: '6',
  // 终态
  REJECTED: '8',
  // 终态
  CANCELLED: '9',
  CANCELLATION_APPLIED: '10',
  APPLIED: '11'
}

export const CaseStateCodeNames = {
  // 保司已受理
  0: '完成报案',
  1: '完成查勘',
  3: '完成定损',
  4: '完成核赔',
  5: '赔款支付',
  // 终态
  6: '案件结案',
  // 终态
  8: '案件驳回',
  // 终态
  9: '案件注销',
  10: '已提交注销申请',
  // 报案申请已提交，但保司还未受理
  11: '已申请'
}

export const SINGLE_TITLE = 'CARD_STYLE_SINGLE_TITLE'

export const OrderStates = {
  WAIT_PAY: '100',
  EARNEST_PAY_SUCCESS: '150',
  DOWN_PAYMENT_PAY_SUCCESS: '200',
  CONTRACT_SUCCESS: '400',
  LOCK_VIN_SUCCESS: '450',
  CAR_DEPART: '456',
  ACCEPTANCE_STORE: '460',
  END_PAID: '500',
  VEHICLE_SHIPPED: '505',
  INVOICE: '510',
  TO_BE_DELIVERED: '550',
  CAR_DELIVER_FINISH: '600',
  REFUND_ADVANCE: '250',
  REFUND_CASH: '300',
  REFUND_SUCCESS: '350',
  RETURN_CAR: '650',
  RETURN_CAR_STORAGE: '700',
  RETURN_CAR_AUDIT: '750',
  RETURN_CAR_SUCCESS: '800',
  CLOSED: '900',
  INVALID: '910'
}

export const OrderStateNames = {
  100: '待支付',
  150: '意向金已支付',
  200: '定金已支付',
  400: '购车协议已签署',
  450: '配车已完成',
  456: '车辆运输中',
  460: '车辆整备中',
  500: '尾款已支付',
  505: '车辆已出库',
  510: '车辆已开票',
  550: '车辆待交付',
  600: '交付已完成',
  250: '退订中',
  300: '退款中',
  350: '已退款',
  650: '退车中',
  700: '退车已入库',
  750: '退车财务审核',
  800: '退车已完成',
  900: '已关闭',
  910: '订单已失效'
}

export const REQUEST_SUCCESS_CODE = 200
// 没有数据权限
export const DATA_PERM_ERR_CODE = 23000015

export const PolicyStates = {
  QUOTED: 800, // 不展示在订单列表
  QUOTE_FAILED: 801, // 不展示在订单列表
  UNPAID: 805,
  PAID: 806,
  CANCELLED: 810,
  MANUAL_VERIFYING: 815,
  MANUAL_VERIFY_SUCCEED: 816,
  MANUAL_VERIFY_FAILED: 820,
  AUTO_VERIFY_SUCCEED: 823,
  TIMEDOUT: 824, // 不展示在订单列表
  PAY_FAILED: 825,
  AUTO_VERIFY_FAILED: 826,
  MANUAL_UNVERIFIED: 827,
  INSURED: 828,
  INSURE_FAILED: 829,
  INSURE_DUPLICATE: 830
}

export const PolicyStateNames = {
  [PolicyStates.QUOTED]: '已报价', // 不展示在订单列表
  [PolicyStates.QUOTE_FAILED]: '报价失败', // 不展示在订单列表
  [PolicyStates.UNPAID]: '待支付',
  [PolicyStates.PAID]: '已支付',
  [PolicyStates.CANCELLED]: '已取消',
  [PolicyStates.MANUAL_VERIFYING]: '人工核保中',
  [PolicyStates.MANUAL_VERIFY_SUCCEED]: '人工核保成功',
  [PolicyStates.MANUAL_VERIFY_FAILED]: '人工核保失败',
  [PolicyStates.AUTO_VERIFY_SUCCEED]: '自动核保成功',
  [PolicyStates.TIMEDOUT]: '已超时', // 不展示在订单列表
  [PolicyStates.PAY_FAILED]: '支付失败',
  [PolicyStates.AUTO_VERIFY_FAILED]: '自动核保失败',
  [PolicyStates.MANUAL_UNVERIFIED]: '待人工核保',
  [PolicyStates.INSURED]: '已承保',
  [PolicyStates.INSURE_FAILED]: '承保失败',
  [PolicyStates.INSURE_DUPLICATE]: '重复投保'
}

export const SerialFlags = {
  HTJJ: 'HTJJ',
  CCJJ: 'CCJJ',
  SDJJ: 'SDJJ',
  ZXBD: 'ZXBD'
}

export const SerialFlagNames = {
  HTJJ: '华泰经纪',
  CCJJ: '车车经纪',
  SDJJ: '盛大代理',
  ZXBD: '智选保代'
}

export type OPERATOR = 'eq' | 'lt' | 'le' | 'gt' | 'ge' | 'and' | 'contain' | 'notIn' | 'between'

// 服务包订单状态
export const PkgOrderStates = {
  PLACED: 1,
  PENDING: 2,
  PART: 3,
  PAID: 4,
  ORDERED: 5,
  REFUNDING: 6,
  REFUNDED: 7,
  CANCELLED: 8
}

// export const PkgOrderStateNames = {
//   [PkgOrderStates.PLACED]: '已下单',
//   [PkgOrderStates.PENDING]: '待支付',
//   [PkgOrderStates.PART]: '现金已支付积分未支付',
//   [PkgOrderStates.PAID]: '已支付',
//   [PkgOrderStates.ORDERED]: '已出单',
//   [PkgOrderStates.REFUNDING]: '退款中',
//   [PkgOrderStates.REFUNDED]: '已退款',
//   [PkgOrderStates.CANCELLED]: '已取消'
// }

// 开票状态
export const InvoiceStatuses = {
  PENDING: 0,
  PROCESSING: 1,
  DONE: 2
}

// export const InvoiceStatusNames = {
//   [InvoiceStatuses.PENDING]: '未开票',
//   [InvoiceStatuses.PROCESSING]: '开票中',
//   [InvoiceStatuses.DONE]: '已开票'
// }
